//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import mixpanel from "mixpanel-browser";

class MixpanelLogger {
  constructor(store) {
    this.mixpanel = mixpanel;
    this.isInitilized = false;
    this.currentStep = null;
    this.store = store;
  }

  async init(token, options = {}) {
    if (!token) {
      return;
    }
    const initOptions = options.api_host ? { api_host: options.api_host } : {};
    await this.mixpanel.init(token, initOptions);
    this.isInitilized = true;
  }

  log(title, details = {}) {
    if (!this.isInitilized) {
      console.log("mixpanel log: ", title, details);
      return;
    }
    details.distinct_id = details.userId;
    details = { ...details, ...details.options };
    delete details.options;

    this.mixpanel.track(title, details);
  }
}

export default MixpanelLogger;
